import ForgotForm from './ForgotForm';

export default ForgotForm;
